<template>
  <div>
    <div>
      <h2 class="th-title">Daftar Customers</h2>
    </div>
    <a-card>
      <div class="d-flex justify-content-between">
        <a-input-search
          placeholder="Cari Nama Customer..."
          v-model:value="search"
          style="width: 250px;"
          class="mb-3"
        />
        <router-link :to="{ path: `/customers/create` }">
          <a-button> <PlusOutlined />New Customers </a-button>
        </router-link>
      </div>
      <div>
        <a-table :columns="columns" :data-source="data" :loading="loading" bordered>
          <template #name="{ text, record }">
            <router-link :to="{ path: `/customers/${record.id}` }" class="vb__utils__link">
              {{ text }}
            </router-link>
          </template>
          <template #action="{ record }">
            <a-button type="danger" @click="openDeleteModal(record.id)">
              <RestOutlined :style="{ color: 'white' }" />
            </a-button>
          </template>
        </a-table>
      </div>
    </a-card>

    <a-modal
      v-model:visible="isDeleteModalVisible"
      title="Konfirmasi Penghapusan"
      ok-text="Hapus"
      ok-type="danger"
      cancel-text="Batal"
      centered
      @ok="handleDelete"
      @cancel="closeDeleteModal"
    >
      <p>
        Apakah Anda yakin ingin menghapus customer ini? Semua data terkait (lokasi, aset) juga
        mungkin akan terpengaruh.
      </p>
    </a-modal>
  </div>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import { notification } from 'ant-design-vue'
import { PlusOutlined, RestOutlined } from '@ant-design/icons-vue'
import { getCustomers } from '../../services/axios/modc/customer'
import { deleteCustomers } from '../../services/axios/modc/users'

const columns = [
  { title: 'No', dataIndex: 'key', key: 'key' },
  { title: 'Nama Customers', dataIndex: 'name', key: 'name', slots: { customRender: 'name' } },
  { title: 'Customers Sign', dataIndex: 'customerSign', key: 'customerSign' },
  { title: 'Customers Email', dataIndex: 'email', key: 'email' },
  { title: 'PIC', dataIndex: 'PIC', key: 'PIC' },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', key: 'mobileNumber' },
  // Tambahkan kolom Action
  { title: 'Action', key: 'action', slots: { customRender: 'action' }, align: 'center' },
]

export default {
  components: {
    PlusOutlined,
    RestOutlined,
  },

  setup() {
    const data = ref([])
    const search = ref('')
    const loading = ref(false)

    // State untuk mengontrol modal
    const isDeleteModalVisible = ref(false)
    const customerIdToDelete = ref(null)

    // Fungsi untuk mengambil data customer
    const fetchCustomers = async (searchTerm = '') => {
      loading.value = true
      try {
        const { customer } = await getCustomers(searchTerm)
        data.value = customer.map((cust, index) => ({
          ...cust,
          key: index + 1,
        }))
      } catch (error) {
        console.error('Gagal mengambil data customer:', error)
        notification.error({
          message: 'Gagal Memuat Data',
          description: 'Terjadi kesalahan saat mengambil daftar customer.',
        })
      } finally {
        loading.value = false
      }
    }

    // Panggil saat komponen dimuat
    onMounted(fetchCustomers)

    // Panggil saat ada pencarian
    watch(search, newValue => {
      fetchCustomers(newValue)
    })

    // Fungsi utama untuk menghapus customer
    const deleteCustomer = async customerId => {
      try {
        console.log(customerId)
        await deleteCustomers(customerId)

        notification.success({
          message: 'Berhasil',
          description: 'Customer telah berhasil dihapus.',
        })
        await fetchCustomers() // Muat ulang daftar setelah sukses
      } catch (error) {
        console.error('Gagal menghapus customer:', error)
        notification.error({
          message: 'Gagal Menghapus',
          description: 'Terjadi kesalahan saat mencoba menghapus customer.',
        })
      }
    }

    // Fungsi untuk membuka modal
    const openDeleteModal = customerId => {
      customerIdToDelete.value = customerId
      isDeleteModalVisible.value = true
    }

    // Fungsi untuk menutup modal
    const closeDeleteModal = () => {
      isDeleteModalVisible.value = false
      customerIdToDelete.value = null
    }

    // Fungsi yang dipanggil saat tombol OK modal ditekan
    const handleDelete = () => {
      if (customerIdToDelete.value) {
        deleteCustomer(customerIdToDelete.value)
      }
      closeDeleteModal()
    }

    return {
      data,
      columns,
      search,
      loading,
      isDeleteModalVisible,
      openDeleteModal,
      closeDeleteModal,
      handleDelete,
    }
  },
}
</script>
